export default __webpack_public_path__ + "static/media/ret1.cdf670f8.jpeg";